::ng-deep app-spreadsheet-manage-entity-dialog{height:100%;display:flex;width:100%;min-height:500px}
/*# sourceMappingURL=spreadsheet-manage-entity-dialog.component-VHZYZX5B.css.map */
